import { Component, Inject, AfterViewInit, ViewChild } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DefaultValuesService } from "../../../services/defaultvalues.service";
import { MatTabGroup } from "@angular/material/tabs";

@Component({
    selector: "controllertypes-configurations",
    templateUrl: './controllertypes-configurations.component.html',
    styleUrls: ['../../../style/container-tab-list.component.less'],
    standalone: false
})

export class ControllerTypesConfigurationsComponent{

    title: string;
    @ViewChild('tabGroup') tabGroup!: MatTabGroup;

    constructor(
        private http: HttpClient
        , @Inject('BASE_URL') private baseUrl: string
        , public defaults: DefaultValuesService
    ) {
        this.title = "ControllerType Configurations";
    }
    ngAfterViewInit() {
        this.defaults.defaultComponentTab(this)
    }
}